import App, { Container } from 'next/app'
import { Provider } from 'react-redux'
import initializeStore from '../../store/initStore'
import _get from 'lodash/get'
import _omit from 'lodash/omit'

import http from '../../lib/http'

const isServer = typeof window === 'undefined'
const __NEXT_REDUX_STORE__ = '__NEXT_REDUX_STORE__'
const checkServer = () => Object.prototype.toString.call(global.process) === '[object process]'

function getOrCreateStore(initialState) {
  // Always make a new store if server, otherwise state is shared between requests
  if (isServer) {
    return initializeStore(initialState)
  }

  // Store in global variable if client
  if (!window[__NEXT_REDUX_STORE__]) {
    window[__NEXT_REDUX_STORE__] = initializeStore(initialState)
  }
  return window[__NEXT_REDUX_STORE__]
}

export default App => {
  return class Redux extends React.Component {
    static async getInitialProps (props = {}) {
      props.req = props.ctx.req

      const isServer = checkServer()
      const initialState = getOrCreateStore().getState()

      if (process.env.NODE_ENV === 'development') {
        console.log('initialState init values: ', initialState)
      }

      if (isServer) {
        let cookies = props && props.req && props.req.cookies ? props.req.cookies : initialState.cookies

        if (typeof cookies === 'object') {
          cookies = Object.keys(cookies).map(key => key + "=" + cookies[key]).join("; ")
        }

        const httpRequest = http(cookies)
        const user = _get(props, 'req.user')

        let isAuthenticated = props.req.isAuthenticated()

        let userData = null
        if (isAuthenticated && user && user.id) {
          try {
            userData = await httpRequest.get(`/account/${user.id}`)
          } catch(e) {
            logger.error(e)
          }
        }

        if (userData) {
          initialState.user = {
            ...initialState.user,
            details: {
              ..._omit(userData.data, ['address', 'login_history'])
            },
            address: {
              ...userData.data.address
            },
            isAuthenticated: isAuthenticated,
            hasRemoteSessions: userData.data.hasRemoteSessions,
            isAdmin: userData.data.is_admin
          }
        }

        let regionsData = {
          data: []
        }
        let productsData = null
        let softwareLinksData = null

        try {
          productsData = await httpRequest.get('/products')
        } catch(e) {
          logger.error(e)
        }

        initialState.products.list = productsData.data && productsData.data.length ?
          productsData.data : []

        try {
          regionsData = await httpRequest.get('/regions')
        } catch(e) {
          logger.error(e)
        }
        try {
          softwareLinksData = await httpRequest.get('/software-link')
        } catch(e) {
          logger.error(e)
        }

        initialState.global.isAuthenticated = isAuthenticated

        if (props.req.session.cart && props.req.session.cart.items) {
          initialState.cart = props.req.session.cart
        } else {
          props.req.session.cart = initialState.cart
        }

        initialState.global.regions = {}
        initialState.global.regions.list = regionsData.data
        initialState.global.regions.country = {}
        initialState.global.regions.country.byCode = {
          'US': 'United States',
          'CA': 'Canada'
        }
        initialState.global.regions.country.list = [
          {
            value: 'US',
            label: 'United States'
          },
          {
            value: 'CA',
            label: 'Canada'
          }
        ]
        initialState.global.regions.byCountry = {
          'US': initialState.global.regions.list.filter(item => item.country === 'US'),
          'CA': initialState.global.regions.list.filter(item => item.country === 'CA')
        }

        initialState.global.softwareLinks = softwareLinksData.data

        initialState.cookies = props && props.req && props.req.cookies ? props.req.cookies : initialState.cookies
      }

      const reduxStore = getOrCreateStore(initialState)

      // Provide the store to getInitialProps of pages
      props.ctx.reduxStore = reduxStore

      let appProps = {}
      if (App.getInitialProps) {
        appProps = await App.getInitialProps(props)
      }

      if (process.env.NODE_ENV === 'development') {
        console.log('initialState with prefetched data: ', initialState)
      }

      return {
        ...appProps,
        isServer,
        initialReduxState: {
          ...reduxStore.getState(),
          ...initialState
        }
      }
    }

    constructor(props) {
      super(props)
      this.reduxStore = getOrCreateStore(props.initialReduxState)
    }

    render() {
      return <App {...this.props} reduxStore={this.reduxStore} />
    }
  }
}



// WEBPACK FOOTER //
// ./components/hoc/withRedux.js